import { render } from "./chi-tiet.vue?vue&type=template&id=35e15c03&scoped=true"
import script from "./chi-tiet.vue?vue&type=script&lang=js"
export * from "./chi-tiet.vue?vue&type=script&lang=js"

import "./chi-tiet.vue?vue&type=style&index=0&id=35e15c03&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e15c03"]])

export default __exports__